import { billingTypes } from './actionTypes'
import {
    FetchSubscriptionTypes,
    FetchCustomerPayload,
    FetchCustomerRequest,
    FetchInvoicesRequest,
    FetchPointsTypes,
    SetPointPacks,
    SetBilling,
    SetSubscriptions,
    SetInvoices,
    ICustomer,
    ISubscription,
    TInvoice,
    ICreditPack,
    FetchPlacingPayload,
    FetchPaymentLinkPayload,
    FetchPlacementLinkPayload,
    FetchPaymentStatusPayload,
} from './types'

export const fetchBillingRequest = (
    payload?: FetchCustomerPayload,
): FetchCustomerRequest => ({
    type: billingTypes.FETCH_CUSTOMER_REQUEST,
    payload,
})

export const fetchSubscriptionsAction = (
    lang?: string | undefined,
): FetchSubscriptionTypes => ({
    type: billingTypes.FETCH_SUBSCRIPTION_TYPES,
    payload: { lang },
})

export const fetchCreditsAction = (
    lang?: string | undefined,
): FetchPointsTypes => ({
    type: billingTypes.FETCH_POINTS_TYPES,
    payload: { lang },
})

export const fetchInvoicesAction = (): FetchInvoicesRequest => ({
    type: billingTypes.FETCH_INVOICES,
})

export const SetBillingAction = (payload: {
    customerDetails?: ICustomer
}): SetBilling => ({
    type: billingTypes.SET_CUSTOMER,
    payload,
})

export const SetSubscriptionsAction = (payload: {
    subscriptions: ISubscription[]
}): SetSubscriptions => ({
    type: billingTypes.SET_SUBSCRIPTIONS,
    payload,
})

export const SetCreditsAction = (payload: {
    credits?: ICreditPack[]
}): SetPointPacks => ({
    type: billingTypes.SET_POINT_PACKS,
    payload,
})

export const SetInvoicesAction = (payload: {
    invoices?: TInvoice[]
}): SetInvoices => ({
    type: billingTypes.SET_INVOICES,
    payload,
})

export const FetchPlacingLink = (payload: FetchPlacingPayload) => ({
    type: billingTypes.FETCH_PLACING_LINK,
    payload,
})

export const fetchPlacingTypes = () => ({
    type: billingTypes.FETCH_PLACING_TYPES,
})

export const getPaymentLink = (payload: FetchPaymentLinkPayload) => ({
    type: billingTypes.GET_PAYMENT_LINK,
    payload,
})

export const getPointsLink = (payload: FetchPaymentLinkPayload) => ({
    type: billingTypes.GET_POINTS_LINK,
    payload,
})

export const getPlacementLink = (payload: FetchPlacementLinkPayload) => ({
    type: billingTypes.GET_PLACEMENT_LINK,
    payload,
})

export const getPaymentStatus = (payload: FetchPaymentStatusPayload) => ({
    type: billingTypes.GET_PAYMENT_STATUS,
    payload,
})
